// generated by genversion
export var version = '4.2.0';
//# sourceMappingURL=version.js.map